// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewLoading_root__39ETN","wrapper":"ViewLoading_wrapper__2tirn","line":"ViewLoading_line__303BU","shimmer":"ViewLoading_shimmer__3VkRM"};